import { render, staticRenderFns } from "./CanpayCrewSharePetition.vue?vue&type=template&id=6b3bdf0c&scoped=true&"
import script from "./CanpayCrewSharePetition.vue?vue&type=script&lang=js&"
export * from "./CanpayCrewSharePetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3bdf0c",
  null
  
)

export default component.exports